import React, { useState, useEffect, useRef } from "react";
import { Eye, Users } from "lucide-react";

/**
 * LiveViewers – "Právě prohlíží X lidí" widget.
 * Shows on product detail & category pages.
 * Uses a realistic random count that gently fluctuates.
 */
export default function LiveViewers({ type = "product", slug = "" }) {
    const [count, setCount] = useState(0);
    const base = useRef(0);

    useEffect(() => {
        // Seed a stable base from the slug hash
        let hash = 0;
        for (let i = 0; i < (slug || "").length; i++) {
            hash = ((hash << 5) - hash) + slug.charCodeAt(i);
            hash |= 0;
        }
        const absHash = Math.abs(hash);
        // Products: 1-8, categories: 3-18
        const min = type === "product" ? 1 : 3;
        const max = type === "product" ? 8 : 18;
        base.current = min + (absHash % (max - min + 1));
        setCount(base.current);

        // Fluctuate every 8-15 seconds
        const interval = setInterval(() => {
            const delta = Math.random() > 0.5 ? 1 : -1;
            setCount(prev => {
                const next = prev + delta;
                if (next < 1) return 1;
                if (next > base.current + 4) return base.current + 2;
                return next;
            });
        }, 8000 + Math.random() * 7000);

        return () => clearInterval(interval);
    }, [slug, type]);

    if (!count) return null;

    return (
        <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-amber-50 border border-amber-200/60"
            data-testid="live-viewers-widget">
            <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-500" />
            </span>
            <Eye size={12} className="text-amber-600" />
            <span className="text-xs font-semibold text-amber-700" data-testid="live-viewers-count">
                Prave prohlizi {count} {count === 1 ? "osoba" : count < 5 ? "lide" : "lidi"}
            </span>
        </div>
    );
}
